import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export function Skeleton({ width, height, borderRadius, className }: SkeletonProps) {
  return (
    <div
      className={`skeleton ${className || ''}`}
      style={{ width, height, borderRadius }}
    />
  );
}

export function SkeletonTournamentCard() {
  return (
    <div className="skeleton-tcard">
      <Skeleton height="180px" borderRadius="16px" />
    </div>
  );
}

export function SkeletonRatingBanner() {
  return (
    <div className="skeleton-rating-banner">
      <div className="skeleton-rating-banner__left">
        <Skeleton width="140px" height="22px" borderRadius="6px" />
        <Skeleton width="100px" height="18px" borderRadius="6px" />
      </div>
      <div className="skeleton-rating-banner__right">
        <Skeleton width="60px" height="32px" borderRadius="8px" />
        <Skeleton width="50px" height="32px" borderRadius="8px" />
      </div>
    </div>
  );
}

export function SkeletonPodium() {
  return (
    <div className="skeleton-podium">
      {[56, 72, 56].map((size, i) => (
        <div key={i} className="skeleton-podium__player">
          <Skeleton width={`${size}px`} height={`${size}px`} borderRadius="50%" />
          <Skeleton width="60px" height="12px" borderRadius="4px" />
          <Skeleton width="40px" height="14px" borderRadius="4px" />
          <Skeleton width="100%" height={[56, 72, 44][i] + 'px'} borderRadius="10px 10px 0 0" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonRatingRow() {
  return (
    <div className="skeleton-rating-row">
      <Skeleton width="40px" height="24px" borderRadius="6px" />
      <Skeleton width="44px" height="44px" borderRadius="50%" />
      <div className="skeleton-rating-row__info">
        <Skeleton width="120px" height="16px" borderRadius="4px" />
        <Skeleton width="180px" height="12px" borderRadius="4px" />
      </div>
    </div>
  );
}

export function SkeletonMenuPage() {
  return (
    <div className="skeleton-menu">
      <div className="skeleton-menu__header">
        <Skeleton width="80px" height="28px" borderRadius="6px" />
        <Skeleton width="110px" height="36px" borderRadius="10px" />
      </div>
      <Skeleton height="56px" borderRadius="14px" />
      <div className="skeleton-menu__tabs">
        <Skeleton width="60px" height="34px" borderRadius="10px" />
        <Skeleton width="60px" height="34px" borderRadius="10px" />
        <Skeleton width="80px" height="34px" borderRadius="10px" />
      </div>
      <div className="skeleton-menu__grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="skeleton-menu__card">
            <Skeleton height="100px" borderRadius="12px 12px 0 0" />
            <div className="skeleton-menu__card-body">
              <Skeleton width="70%" height="16px" borderRadius="4px" />
              <Skeleton width="50%" height="14px" borderRadius="4px" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonProfilePage() {
  return (
    <div className="skeleton-profile">
      <div className="skeleton-profile__avatar">
        <Skeleton width="80px" height="80px" borderRadius="50%" />
      </div>
      <Skeleton width="150px" height="20px" borderRadius="6px" />
      <Skeleton width="100px" height="14px" borderRadius="4px" />
      <div className="skeleton-profile__row">
        <Skeleton width="90px" height="36px" borderRadius="20px" />
        <Skeleton width="100px" height="36px" borderRadius="10px" />
      </div>
      <div className="skeleton-profile__stats">
        <Skeleton height="180px" borderRadius="16px" />
      </div>
    </div>
  );
}

export function SkeletonOrdersPage() {
  return (
    <div className="skeleton-orders">
      <Skeleton width="120px" height="28px" borderRadius="6px" />
      <div className="skeleton-orders__list">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="skeleton-orders__item">
            <div className="skeleton-orders__item-top">
              <Skeleton width="60%" height="16px" borderRadius="4px" />
              <Skeleton width="60px" height="24px" borderRadius="8px" />
            </div>
            <Skeleton width="80%" height="12px" borderRadius="4px" />
            <Skeleton width="40%" height="12px" borderRadius="4px" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonTournamentDetail() {
  return (
    <div className="skeleton-td">
      <Skeleton height="200px" borderRadius="16px" />
      <Skeleton height="60px" borderRadius="16px" />
      <Skeleton height="100px" borderRadius="16px" />
      <Skeleton height="80px" borderRadius="16px" />
      <Skeleton height="52px" borderRadius="14px" />
    </div>
  );
}
